import { FREELANCECLIENTACADEMIC } from "../../ENVIRONMENT";

// api for freelance client academic list details
function freeacademicList(token) {
  const response = fetch(FREELANCECLIENTACADEMIC, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { freeacademicList };
